import { Observable, map } from 'rxjs';

export type PlantillaReporte = 'tabla' | 'tabla-expandible' | 'f29-observado' | 'agentes-retenedores' | 'devoluciones-iva';

export interface GraficoTabla {
    datos: string;
    titulo: string;
    subtitulo: string;
    tipo: 'line' | 'bar' | 'pie' | 'doughnut';
}

export interface SubTabla {
    datos: string;
    noData: string;
    columnas: ColumnaReporte[];
}

export interface ColumnaReporte {
    nombre: string;
    titulo: string;
    clase?: string;
    formato?: 'moneda' | 'fecha' | 'fechaHora' | 'mesAnio' | 'estado' | 'persona';
    secundario?: string;
    subTabla?: SubTabla;
}

export interface Tabla {
    datos: string;
    titulo: string;
    subtitulo: string;
    columnas: ColumnaReporte[];
    grafico?: GraficoTabla;
}

export interface DatosReporte {
    tituloReporte: string;
    tituloMenu?: string;
    subtituloReporte: string;
    tablas: Tabla[];
    anio?: boolean;
    plantilla?: PlantillaReporte;
    icono?: string;
    visibleEnMenu?: boolean;
}

export interface ParametrosConsultaReporte {
    idcliente: number;
    anio: number;
    mes: number;
}

export interface ResultadoReporte<TData = unknown> {
    data: TData;
    tablas?: Tabla[];
}

export interface EstrategiaReporte<TDto = unknown, TData = TDto> {
    consultar: (parametros: ParametrosConsultaReporte) => Observable<TDto>;
    transformar: (dto: TDto, parametros: ParametrosConsultaReporte) => ResultadoReporte<TData>;
    codigoJob?: string;
}

export class Reporte<TId extends string = string, TDatos extends DatosReporte = DatosReporte, TDto = unknown, TData = TDto> {
    constructor(
        readonly id: TId,
        readonly datos: TDatos,
        private readonly estrategia: EstrategiaReporte<TDto, TData>
    ) {}

    readonly consultar = (parametros: ParametrosConsultaReporte): Observable<ResultadoReporte<TData>> => {
        return this.estrategia.consultar(parametros).pipe(map((dto) => this.estrategia.transformar(dto, parametros)));
    };

    get codigoJob(): string {
        return this.estrategia.codigoJob ?? this.id.toUpperCase();
    }
}

export type ReporteRegistrado<TDatos extends DatosReporte = DatosReporte> = Reporte<string, TDatos, any, any>;
